// avstemming-bank-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'avab.flag.notBooked': 'Not booked',
  'avab.flag.manualReview': 'Pending manual review',
  'avab.flag.missingVoucher': 'Missing voucher',
  'avab.flag.possibleDuplicate': 'Possible duplicate',
  'avab.assess.notAssessed': 'Not assessed',
  'avab.assess.noCorrection': 'No correction needed',
  'avab.assess.transit': 'Timing difference against bank',
  'avab.assess.missingBooking': 'Missing booking',
  'avab.assess.wrongBooking': 'Wrong booking — to be corrected',
  'avab.assess.duplicate': 'Duplicate',
  'avab.assess.internalTransfer': 'Internal transfer',
  'avab.assess.bankFee': 'Bank fee',
  'avab.assess.interest': 'Interest',
  'avab.assess.currencyDifference': 'Currency difference',
  'avab.assess.wrongBankAccount': 'Wrong bank account',
  'avab.assess.shouldReverse': 'The booking is to be reversed',
  'avab.assess.awaitingDocs': 'Awaiting documentation',
  'avab.assess.awaitingClient': 'Awaiting the client',
  'avab.assess.nextPeriod': 'Follow up next period',
  'avab.nav.overview': 'Overview',
  'avab.nav.accounts': 'Bank accounts',
  'avab.nav.accountsCount': '{ok}/{total} agree',
  'avab.nav.transactions': 'Transactions',
  'avab.nav.openCount': '{count} open',
  'avab.nav.documentation': 'Documentation',
  'avab.nav.missingCount': '{count} missing',
  'avab.nav.complete': 'Complete',
  'avab.nav.deviations': 'Deviations and actions',
  'avab.nav.controls': 'Review and approval',
  'avab.noReconciliationAccount': 'The bank account has no reconciliation account in this period.',
  'avab.bank': 'Bank',
  'avab.activeAccount': 'Bank account: {name}',
  'avab.showAllAccounts': 'Show all bank accounts',
  'avab.resetFilters': 'Reset filters',
  'avab.common.description': 'Description',
  'avab.common.bankDate': 'Bank date',
  'avab.common.bookingDate': 'Booking date',
  'avab.common.voucher': 'Voucher',
  'avab.common.bankAmount': 'Bank amount',
  'avab.common.bookedAmount': 'Booked amount',
  'avab.common.difference': 'Difference',
  'avab.common.assessment': 'Assessment',
  'avab.common.close': 'Close',
  'avab.tx.colMatch': 'Match',
  'avab.tx.colFlag': 'Alert',
  'avab.tx.noFlags': 'None',
  'avab.tx.assess': 'Assess',
  'avab.tx.viewAssessment': 'View assessment',
  'avab.tx.noMatchingLines': 'No bank lines match the filters.',
  'avab.tx.noStatement': 'No bank statement covers this period. Without a bank basis the bank cannot be reconciled.',
  'avab.drawer.noBankMatch': 'No bank match',
  'avab.drawer.matchStatus': 'Match status',
  'avab.drawer.attachment': 'Attachment',
  'avab.drawer.reasonRequired': 'Justification (required)',
  'avab.drawer.reason': 'Justification',
  'avab.drawer.reasonPlaceholder': 'What does the review of this line show?',
  'avab.drawer.action': 'Action',
  'avab.drawer.actionPlaceholder': 'E.g. Investigate or reverse',
  'avab.drawer.followUpDue': 'Follow-up deadline',
  'avab.drawer.followUpNote': 'The line will appear as a follow-up suggestion under "Conclusion and approval".',
  'avab.drawer.needsReason': 'This assessment requires a justification.',
  'avab.drawer.save': 'Save assessment',
  'avab.drawer.askClient': 'Ask the client for documentation',
  'avab.common.account': 'Account',
  'avab.common.date': 'Date',
  'avab.common.type': 'Type',
  'avab.common.amount': 'Amount',
  'avab.common.status': 'Status',
  'avab.sections.responsible': 'Responsible {name}',
  'avab.sections.title': 'Bank – general ledger against bank',
  'avab.sections.noAccounts': 'No bank accounts set up for reconciliation',
  'avab.sections.unassessed': '{count} bank items require assessment before the reconciliation can be sent for review.',
  'avab.sections.noneUnassessed': 'No bank items remain to be assessed.',
  'avab.sections.notLinked': 'None of the bank accounts are linked to a general ledger account in this period. Without the link there are no ledger lines to compare the bank basis with — the check has not been run; it did not find nothing. The link is set up under Settings.',
  'avab.cur.title': 'Accounts in foreign currency',
  'avab.cur.none': 'None of the company\'s bank accounts are held in a foreign currency. Then there is no conversion to check.',
  'avab.cur.noLedgerAccount': 'The bank account has no general ledger account in this period.',
  'avab.cur.intro': 'The bank reports the balance in the account\'s currency, the general ledger holds it in kroner. The difference between them is a conversion — not a deviation in the bank basis.',
  'avab.cur.bankBalance': 'Bank balance',
  'avab.cur.rate': 'Rate {date}',
  'avab.cur.converted': 'Converted',
  'avab.cur.booked': 'Booked',
  'avab.cur.conversionDifference': 'Conversion difference',
  'avab.cur.noted': 'Quoted {date}',
  'avab.cur.noRate': 'No rate quoted',
  'avab.cur.fetchRate': 'Fetch rate',
  'avab.cur.explained': 'Explained',
  'avab.cur.explain': 'Explain the conversion',
  'avab.cur.footnote': 'The rate is Norges Bank\'s quotation. The conversion difference is booked as unrealised currency gain or loss — the reconciliation shows it, it does not book it.',
  'avab.transit.title': 'Booked without a bank match',
  'avab.transit.allMatched': 'All bookings on the bank accounts have been found in the bank statement. No items are waiting for the bank.',
  'avab.transit.intro': 'Postings on the bank accounts that have not been found in the bank statement. The matching is a suggestion — same amount within six days — not a booking decision.',
  'avab.transit.kpiItems': 'Items without a bank match',
  'avab.transit.kpiNeedsAssessment': '{count} need assessment',
  'avab.transit.kpiItemsHint': 'Bookings on the bank accounts without a corresponding bank line.',
  'avab.transit.kpiNormal': 'Normal timing difference',
  'avab.transit.kpiNormalHint': 'Booked up to 30 days before period end — the payment may still be on its way.',
  'avab.transit.kpiOld': 'Older than 30 days',
  'avab.transit.kpiOldHint': 'Too old to be a timing difference. Must be investigated or reversed.',
  'avab.transit.kpiTotal': 'Total amount',
  'avab.transit.kpiTotalHint': 'The amount these postings make up of the difference against the bank.',
  'avab.transit.colAge': 'Age',
  'avab.transit.days': '{count} days',
  'avab.transit.needsAssessment': 'Needs assessment',
  'avab.transit.timingDifference': 'Timing difference against bank',
  'avab.int.title': 'Internal transfers',
  'avab.int.none': 'No vouchers in the period touch two of the company\'s own bank accounts.',
  'avab.int.offOne': '{count} transfer does not add up. The difference is usually a fee the bank deducted along the way, or a conversion between accounts in different currencies — both must be booked.',
  'avab.int.offMany': '{count} transfers do not add up. The difference is usually a fee the bank deducted along the way, or a conversion between accounts in different currencies — both must be booked.',
  'avab.int.allOk': 'All transfers between the company\'s own bank accounts add up.',
  'avab.int.colFrom': 'From',
  'avab.int.colTo': 'To',
  'avab.int.colOut': 'Out',
  'avab.int.colIn': 'In',
  'avab.int.deviation': 'Deviation',
  'avab.int.checked': 'Checked',
  'avab.fees.title': 'Bank fees and interest',
  'avab.fees.none': 'No vouchers in the period post a fee or interest against the bank accounts. A fee the bank has deducted that is not booked appears as an unbooked bank line in the transaction list.',
  'avab.fees.intro': 'Taken from the general ledger — vouchers that touch a bank account and a fee or interest account. Fees the bank has deducted that are not booked appear as unbooked bank lines in the transaction list.',
  'avab.fees.colCount': 'Count',
  'avab.fees.sum': 'Total',
  'avab.fees.items': 'The items',
  'avab.fees.colText': 'Text',
  'avab.fees.kind.fee': 'Fee',
  'avab.fees.kind.interestIncome': 'Interest income',
  'avab.fees.kind.interestExpense': 'Interest expense',
  'avab.quick.requiresAssessment': 'Requires assessment',
  'avab.quick.all': 'All',
  'avab.quick.matched': 'Matched',
  'avab.quick.suggested': 'Suggested match',
  'avab.quick.manualReview': 'For manual review',
  'avab.quick.unmatchedBank': 'Unmatched bank',
  'avab.quick.notBooked': 'Not booked',
  'avab.quick.missingVoucher': 'Missing voucher',
  'avab.quick.possibleDuplicates': 'Possible duplicates',
  'avab.quick.held': 'Held outside',
  'avab.quick.assessed': 'Assessed',
  'avab.bal.title': 'Automatic balance reconciliation',
  'avab.bal.noComparable': 'No accounts can be compared',
  'avab.bal.settledBadge': 'Balance reconciled after items in transit',
  'avab.bal.unexplainedBadge': 'Unexplained difference',
  'avab.bal.noComparableText': 'No bank account has both a booked balance and a bank balance in this period. Without both sides there is no difference to reconcile.',
  'avab.bal.bookedAll': 'Booked balance, all bank accounts',
  'avab.bal.bankPerDate': 'Balance according to bank as of {date}',
  'avab.bal.preliminary': 'Preliminary difference',
  'avab.bal.bookedWithoutMatch': 'Booked without a bank match',
  'avab.bal.unexplained': 'Unexplained difference',
  'avab.bal.settledText': 'The booked balance and bank balance can be reconciled after {amount} in postings that have not yet been found in the bank. Each of them must still be assessed.',
  'avab.bal.unexplainedText': '{amount} of the difference is not explained by items in transit and must be investigated.',
  'avab.bal.excluded': '{count} account is excluded from the comparison — a foreign currency account or missing bank basis.',
  'avab.bal.previousBalance': 'Balance previous period',
  'avab.bal.change': 'Change in the period',
  'avab.bal.bankTransactions': 'Bank transactions',
  'avab.bal.bookedTransactions': 'Booked bank transactions',
  'avab.bal.notBooked': 'Not booked',
  'avab.bal.coverageComplete': 'Bank basis complete',
  'avab.bal.coveredOf': '{covered} of {total}',
  'avab.bal.basisNote': 'The basis is the bank statements covering {from} to {to}, and the trial balance for the same period.',
  'avab.cov.title': 'Documentation coverage per bank account',
  'avab.cov.incompleteOne': 'The bank basis does not cover the whole period for {count} bank account.',
  'avab.cov.incompleteMany': 'The bank basis does not cover the whole period for {count} bank accounts.',
  'avab.cov.colBankAccount': 'Bank account',
  'avab.cov.colFrom': 'From date',
  'avab.cov.colTo': 'To date',
  'avab.cov.colCoverage': 'Coverage',
  'avab.cov.colSource': 'Source',
  'avab.cov.noStatement': 'No statement',
  'avab.cov.incomplete': 'Incomplete',
  'avab.cov.requestStatement': 'Request account statement for {account}',
  'avab.ctl.ledgerVsBank': 'General ledger against bank',
  'avab.ctl.settledOf': '{settled} of {total} reconciled',
  'avab.ctl.ledgerVsBankHint': 'Booked balance compared with the bank balance per bank account.',
  'avab.ctl.unbookedLines': 'Unbooked bank lines',
  'avab.ctl.unbookedLinesHint': 'Bank lines without a corresponding booking.',
  'avab.ctl.olderThan30': '{count} older than 30 days',
  'avab.ctl.noMatchHint': 'Postings on the bank accounts that have not been found in the bank statement.',
  'avab.ctl.manualHint': 'Bank lines the bank view has set to manual review.',
  'avab.ctl.duplicateHint': 'Same account, date, amount and text.',
  'avab.ctl.missingDocs': 'Missing documentation',
  'avab.ctl.bankAccountOne': 'bank account',
  'avab.ctl.bankAccountMany': 'bank accounts',
  'avab.ctl.missingDocsHint': 'Bank account with incomplete period coverage.',
  'avab.ctl.missingVoucherHint': 'Payments without an attachment, without an exemption and without the bank statement being approved as a voucher.',
  'avab.ctl.internalDeviations': 'Internal transfers with deviations',
  'avab.ctl.internalDeviationsHint': 'Transfers between the company\'s own bank accounts that do not add up.',
  'avab.ctl.feeItems': 'Fee and interest items',
  'avab.ctl.feeItemsHint': 'Vouchers that touch a bank account and a fee or interest account.',
  'avab.ctl.foreignHint': 'Accounts where the bank balance must be converted before it can be compared.',
  'avab.ctl.linesInPeriod': 'Bank lines in the period',
  'avab.ctl.linesInPeriodHint': 'All lines in the bank basis for the period.',
  'avab.ctl.bookedLines': 'Booked bank lines',
  'avab.ctl.bookedLinesHint': 'Bank lines that have been matched against a booking.',
  'avab.ctl.title': 'Control card',
  'avab.ctl.summary': 'Automatic checks run: {run} of {total} · Checks with findings: {findings} · Items with alerts: {flagged}',
  'avab.ctl.hide': 'Hide',
  'avab.ctl.showAll': 'Show all automatic checks',
  'avab.ctl.activeFilter': 'Active filter: {flag} · {count} items',
  'avab.ctl.removeFilter': 'Remove filter',
  'avab.checks.title': 'Automatic checks',
  'avab.checks.intro': 'The checks do not tick off anything in the professional checklist. They say what the person ticking off should have looked at.',
  'avab.checks.colCheck': 'Check',
  'avab.checks.colRun': 'Run',
  'avab.checks.colFindings': 'Findings',
  'avab.checks.run': 'Run',
  'avab.checks.findings': '{count} findings',
  'avab.checks.noFindings': 'No findings',
  'avab.match.title': 'Matching overview',
  'avab.match.remainingOne': '{pct} % of the period\'s items are matched. {count} item remains.',
  'avab.match.remainingMany': '{pct} % of the period\'s items are matched. {count} items remain.',
  'avab.acc.status.currency': 'Currency must be checked',
  'avab.acc.notCompared': 'Not compared',
  'avab.acc.status.agrees': 'Agrees',
  'avab.acc.status.reconciled': 'Reconciled',
  'avab.acc.intro': 'Click a row to filter the whole view to that bank account.',
  'avab.acc.colCurrency': 'Currency',
  'avab.acc.colBookedBalance': 'Booked balance',
  'avab.acc.colExplained': 'Explained',
  'avab.acc.colUnexplained': 'Unexplained',
  'avab.acc.lineCount': '{count} lines',
  'avab.acc.requiresConversion': 'Requires conversion',
  'avab.acc.incompleteBasis': 'Incomplete bank basis',
  'avab.acc.openAccount': 'Open account',
  'avab.acc.noAccounts': 'The company has no bank accounts set up for reconciliation. The accounts are set up under Settings.',
  'avab.derived.notBooked': 'Unbooked bank lines have been processed',
  'avab.derived.manualReview': 'Bank lines for manual review have been processed',
  'avab.derived.missingVoucher': 'Payments without a voucher have been processed',
  'avab.derived.possibleDuplicate': 'Possible duplicates have been assessed',
  'avab.chk.title': 'Professional checklist',
  'avab.chk.titleReadOnly': 'Professional checklist (the preparer\'s, read-only)',
  'avab.chk.noItems': 'No checkpoints are defined for bank in this period.',
  'avab.chk.intro': 'The items apply to the whole bank area. A tick is saved on all the bank accounts in the period.',
  'avab.chk.groupItems': 'Items that require processing',
  'avab.chk.countOf': '{done} of {total}',
  'avab.chk.processedOf': '{done} of {total} processed',
  'avab.chk.notApplicable': 'Not applicable this period',
  'avab.chk.followsAssessments': 'Follows from the assessments',
  'avab.chk.groupAssessments': 'Overall professional assessments',
  'avab.chk.groupReady': 'Readiness',
  'avab.chk.performedBy': 'Performed by {name}',
  'avab.chk.completedOf': '{done} of {total} checkpoints completed',
  'avab.blk.linesOne': '{count} bank line requires assessment',
  'avab.blk.linesMany': '{count} bank lines require assessment',
  'avab.blk.unexplained': '{amount} of the difference against bank is unexplained',
  'avab.blk.coverageOne': '{count} bank account has an incomplete bank basis',
  'avab.blk.coverageMany': '{count} bank accounts have an incomplete bank basis',
  'avab.blk.staleOne': '{count} booking without a bank match is older than 30 days',
  'avab.blk.staleMany': '{count} bookings without a bank match are older than 30 days',
  'avab.blk.checklistOne': '{count} checkpoint remains',
  'avab.blk.checklistMany': '{count} checkpoints remain',
  'avab.concl.title': 'Conclusion and approval',
  'avab.concl.label': 'Conclusion',
  'avab.concl.placeholder': 'What does the review of the bank show for this period?',
  'avab.concl.note': 'Saved as the justification on the checkpoint "{label}".',
  'avab.concl.remainingRisk': 'Remaining risk',
  'avab.concl.nothingLeft': 'Nothing remains that prevents the area from being sent for review.',
  'avab.concl.followUp': 'Follow-up next period',
  'avab.concl.noFollowUps': 'No assessments are marked for follow-up next period.',
  'avab.concl.followedUp': 'Being followed up',
  'avab.concl.action': 'Action: {action}',
  'avab.concl.noAction': 'No action noted',
  'avab.concl.deadline': 'Deadline {date}',
  'avab.concl.openAssessment': 'Open assessment',
  'avab.concl.sendToControl': 'Send the area for review',
  'avab.concl.oneLeft': 'One thing remains before the area can be sent.',
  'avab.concl.manyLeft': '{count} things remain before the area can be sent.',
});
